<template>
  <div>
    <div class="row m-hide-lg repeater-row-lg">
      <div class="col-lg">
        <label>{{ $t('products.properties.name') }}</label>
      </div>
      <div class="col-lg">
        <label>{{ $t('products.properties.value') }}</label>
      </div>
      <div class="col repeater-last-lg"></div>
    </div>
    <property-row
            :key="index"
            :properties="product.properties"
            :property="property"
            :propertyIndex="index"
            @addPropertyRow="addPropertyRow()"
            @propertyRemoved="removePropertyRow($event)"
            v-for="(property,index) in product.properties"
    />
  </div>
</template>

<script>
  import PropertyRow from './PropertyRow'

  //@vuese
  // @group Products
  export default {
    name: 'ProductProperties',
    components: {PropertyRow},
    props: ['product'],
    methods: {
      //@vueuse
      addPropertyRow() {
        this.product.properties.push({
          name: null,
          propertyValue: null
        });
      },
      //@vueuse
      removePropertyRow(index) {
        this.product.properties.splice(index, 1);
      }
    },
    created() {
      let properties = this.product.properties;
      if(properties.length === 0) {
        this.addPropertyRow();
        this.$emit('addedRow', true)
      }
    }
  }
</script>